<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
			<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Acción problémica">
				<div class="container-fluid">
					<div class="row" id="slide-1">
						<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
							<div class="p-3 pl-lg-5">
								<h2 class="mt-5">Acción problémica</h2>
								<h3>La tabula rasa (mente en blanco) del desarrollo </h3>
								<h5>Tipo de actividad: tarea</h5>
								<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
								<p>Reconocer las nociones generales que tienen los estudiantes sobre el origen de las funciones cognitivas en los seres humanos.</p>
								<h4 class="mt-3">¿Qué hacer?</h4>
								
								
								<div class="row mb-xl-5 mb-lg-5 mb-0">
									<div class="col-12 d-flex">
										<span class="numeracionMorada1 mr-2">1</span>
										<p>Responda la siguiente pregunta:<br><br>¿Son las mentes de los niños y niñas al nacer una tabula rasa (mente en blanco) que busca ser “llenada” desde el exterior?</p>
									</div>
									<div class="col-12 d-flex">
										<span class="numeracionMorada1 mr-2">2</span>
										<p>Genere cinco argumentos que den cuenta de su posición sobre la pregunta. </p>
									</div>
									<div class="col-12 d-flex mt-xl-0 mt-lg-0 mt-3">
										<span class="numeracionMorada1 mr-2">3</span>
										<p>Con su respuesta a la pregunta recree una situación social en la cual se evidencie su posición.</p>
									</div>
									<div class="col-12 d-flex mt-xl-0 mt-lg-0 mt-3">
										<span class="numeracionMorada1 mr-2">4</span>
										<p>Grabe un video en el que describa con sus propias palabras el ejemplo, y pueda evidenciar la respuesta de la pregunta. </p>
									</div>
									<div class="col-12 d-flex mt-xl-0 mt-lg-0 mt-3">
										<span class="numeracionMorada1 mr-2">5</span>
										<p>Suba el enlace del video a la plataforma, en el lugar donde se encuentra la actividad. </p>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AP justify-content-center align-items-center"> 
							<p class="RefimgActiv">Foto por Paweł Czerwiński en <a href="https://unsplash.com/photos/Q5oCIFL2xKc" target="_blank" class="text-white">Unsplash</a></p>
							<div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
								<div class="row ml-xl-3 ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100">
									<div class="col-lg-12 col-md-12 col-12 p-lg-5 p-3 d-flex align-items-center justify-content-center">	
										<button class="btn BtnPrincipal d-flex mx-auto" onClick="javascript:window.open('http://campusvirtual.itm.edu.co/mod/assign/view.php?id=204036', '_blank');">Ir a la entrega de la actividad</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'AccionProblemica',

      mounted() {
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>